import styled from 'styled-components';

export const SpatialInsightsStyles = styled.section``;
